






































































































































































import TopNav from '@/web/components/navigation/TopNav.vue';
import Vue from 'vue';
import ColorPicker from '@/web/components/settings/ColorPicker.vue';
import HMButton from '@/web/components/common/HMButton.vue';
import { errorToMessage } from '@/core/utils/errors';
import { draggableDelay } from '@/web/utils/draggable';
import draggable from 'vuedraggable';
import { mapGetters } from 'vuex';
import LinkPhotoUploadModal from '@/web/components/settings/BioLinkUpdateModal.vue';
import { cloneDeep } from 'lodash';
import { formatObjectForBackend } from '@/core/api/utils/converter';
import { notify } from '@/web/utils/notify';

export default Vue.extend({
  components: {
    HMButton,
    TopNav,
    ColorPicker,
    draggable,
  },
  name: 'MarvelousBio',
  computed: {
    ...mapGetters({
      bioLinks: 'setting/bioLinks',
      teacher: 'user/teacher',
    }),
  },
  methods: {
    setBioInfo() {
      try {
        this.$store.dispatch(
          'setting/updateMarvelousBioInfo',
          formatObjectForBackend(cloneDeep(this.teacherBio))
        );
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$tc('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$tc('SETTINGS.NOTIFICATIONS.MARVELOUS_BIO_INFO_SAVED'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: errorToMessage(error.response),
        });
      }
    },
    addLink() {
      this.$modal.show(LinkPhotoUploadModal);
    },
    deleteLink(id) {
      try {
        this.$store.dispatch('setting/deleteBioLink', id);
        this.sortedLinks = this.sortedLinks.filter(item => item.id !== id);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$tc('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$tc('SETTINGS.NOTIFICATIONS.LINKS_SUCCESSFULLY_SAVED'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: errorToMessage(error.response),
        });
      }
    },
    async reorderLinks(): Promise<void> {
      const links = this.sortedLinks.map((link, index) => {
        return {
          ...link,
          image: link.image?.id,
          position: index,
        };
      });
      await this.$store.dispatch('setting/reorderBioLinks', links);
      await this.$store.dispatch('setting/getMarvelousBioInfo');
    },
    editLink(link) {
      this.$modal.show(LinkPhotoUploadModal, { link });
    },
    sortPosition(items) {
      this.sortedLinks = items.sort((a, b) => a.position - b.position);
    },
    copyMarvelousBioLink() {
      const bioHostname =
        process.env.VUE_APP_MARVELOUS_BIO_URL || 'https://marvelous.bio';
      const value = `${bioHostname}/${this.teacher.studio_url}`;
      this.$copyText(value).then(() => {
        notify(this.$t('PRODUCTS.TOAST.COPIED') as string, value);
      });
    },
  },
  data() {
    return {
      draggableDelay,
      image: null,
      teacherBio: {},
      sortedLinks: [],
    };
  },
  async mounted() {
    this.teacherBio = await this.$store.dispatch('setting/getMarvelousBioInfo');
  },

  watch: {
    bioLinks: {
      handler(value) {
        this.sortPosition([...this.bioLinks]);
      },
    },
  },
});
